
import { Component, Vue, Prop } from 'vue-property-decorator';
import { parseTime } from '@/utils';
import { getOperationLogList } from '@/api/log';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'SystemSettingLog',
  components: {

  }
})
export default class extends Vue {
  private search: any = {
    operationType: ''
  }
  private tableData: any = [];
  private operationType=[
    { id: 1, value: '推单设置' },
    { id: 3, value: '个性化设置' },
    { id: 5, value: '订单流程设置' },
    { id: 7, value: '模块设置' }
  ]
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private dialogDetailsVisible = false
  private dialogDetails: any = []
  created() {
    this.getOperationLogList();
  }
  private getOperationLogList() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    if (this.search.operationType) {
      pamars.type = this.search.operationType.id;
    }
    getOperationLogList(pamars).then((res:any) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
      }
    }).catch(err => {
      let msg = err.msg;
      this.pagination.total = 0;
      this.tableData = [];
    });
  }
  private searchHandle() {
    this.pagination.currentPage = 1;
    this.getOperationLogList();
  }
  private cleanHandle() {
    this.pagination.currentPage = 1;
    this.search = {};
    this.getOperationLogList();
  }

  private getType(val:any) {
    let nameType = '';
    let oList = this.operationType.filter((o:any) => {
      return o.id === val.type;
    });
    if (oList && oList.length > 0) {
      nameType = oList[0].value;
    }
    return nameType;
  }
  private detailsHandle(val: any) {
    let detail:any = {};
    if (val.user_operation_data) {
      detail = JSON.parse(val.user_operation_data);
    }
    this.dialogDetails = detail;
    this.dialogDetailsVisible = true;
  }
  private handlePageSizeChange(pageSize:any) {
    this.pagination.pageSize = pageSize;
    this.getOperationLogList();
  }
  private handleCurrentChange(page:any) {
    this.pagination.currentPage = page;
    this.getOperationLogList();
  }
}
